<template>
  <div class="registration-form__step registration-form-step-target-group">
    <radio-group-fi
      v-model="targetGroup"
      class="registration-form__step__container registration-form-step-target-group__container"
      name="example"
      text-attribute="title"
      variant="hidden-icon"
      :options="targetGroupList"
      no-style
      required
    >
      <template #default="{ option, isChecked }">
        <div class="registration-form-step-target-group__image-container">
          <div class="registration-form-step-target-group__image">
            <cloud-image-fi
              v-if="targetGroupImage(option.title)"
              :src="targetGroupImage(option.title)"
              :alt="option.title"
              :aspect-ratio="1.778"
              data-test="target-group-image"
              no-drag
            />
          </div>
        </div>
        <div class="registration-form-step-target-group__title">
          <span
            :class="{
              'registration-form-step-target-group__checkbox': true,
              'registration-form-step-target-group__checkbox--checked': isChecked,
            }"
            type="radio"
            role="radio"
            :aria-checked="isChecked"
          />
          {{ option.title }}
        </div>
      </template>
    </radio-group-fi>
  </div>
</template>

<script setup lang="ts">
import { CloudImageFi, RadioGroupFi } from 'atoms';
import { useRegistrationStore } from 'store/registration';
import { computed, onMounted } from 'vue';

import { useFields } from '@/composables/fields';
import { getSelectList, type SelectListField } from '@/utils/fieldTransformations';

defineOptions({ name: 'RegistrationStepTargetGroup' });

type RegistrationStepTargetGroupFields = {
  targetGroupSectorList?: SelectListField;
};

const emit = defineEmits<{
  (e: 'valid-changed', isValid: boolean): void;
}>();

const fields = useFields<RegistrationStepTargetGroupFields>();
const registrationStore = useRegistrationStore();

const targetGroupList = computed<any[]>(() => {
  const [, list] = getSelectList(fields, 'targetGroupSectorList');
  return list;
});

function validate() {
  let isValid = false;

  if (targetGroup.value && targetGroup.value !== '') {
    isValid = true;
  }

  emit('valid-changed', isValid);
}

const targetGroup = computed<string | undefined>({
  get() {
    if (registrationStore.targetGroup !== '') {
      return registrationStore.targetGroup;
    }
    return undefined;
  },
  set(value: string | undefined) {
    const selectedTargetGroup = targetGroupList.value.find((s) => s.value === value);

    registrationStore.targetGroup = value ?? '';
    registrationStore.targetGroupTitle = selectedTargetGroup?.title;
    registrationStore.targetGroupNewsletter = selectedTargetGroup?.newsletter;
    validate();
  },
});

function targetGroupImage(title: string) {
  if (targetGroupList.value) {
    const currentTarget = targetGroupList.value.find((s) => s.title === title);
    if (currentTarget?.image?.src) {
      return currentTarget.image.src;
    }
  }

  return null;
}

onMounted(() => {
  validate();
});
</script>

<style scoped src="./registration-step-target-group" />
